import React from 'react'
import MaterialSymbol from '../material-symbol'

const HowToReg = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="how_to_reg" {...props} />
))

HowToReg.displayName = 'HowToReg'

export default HowToReg
